'use client';

import { useEffect, useState } from 'react';

import { useSearchParams } from 'next/navigation';

const isProd =
  process.env.APP_ENV === 'production' || process.env.APP_ENV === 'qa';

export const useIsAuthorizedToLoadPage = () => {
  const searchParams = useSearchParams();
  // this query param is configured by the acsendo/talent backend
  const urlParent = searchParams.get('urlParent') as string;
  // make the authorized logic required only in production environment
  const [value, setValue] = useState({
    flexSessionId: process.env.FLEX_SESSION_ID,
    isAuthorized: !isProd,
    loading: isProd,
  });

  useEffect(() => {
    if (isProd) {
      window.parent.postMessage(
        {
          event: 'getSession',
        },
        urlParent,
      );

      window.addEventListener('message', message => {
        if (message.data.event === 'sessionId') {
          setValue({
            loading: false,
            isAuthorized: true,
            flexSessionId: message.data.value,
          });
        }
      });
    }
  }, [urlParent]);

  return value;
};
